import { createReducer, createAction } from "@reduxjs/toolkit";
import { adminRetrieveAttendanceSheets } from "./retrieve-attendance-sheets";
import type { TrainingFollowUpAttendanceSheetVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<TrainingFollowUpAttendanceSheetVM[]> = { fetching: "idle", data: [] };

export const resetAdminAttendanceSheetsRetrieval = createAction("trainingFollowUps/resetAdminAttendanceSheets");

export const adminRetrieveAttendanceSheetsReducer = createReducer<RetrievalState<TrainingFollowUpAttendanceSheetVM[]>>(
  initialState,
  builder => {
    builder.addCase(adminRetrieveAttendanceSheets.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(adminRetrieveAttendanceSheets.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(adminRetrieveAttendanceSheets.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
    builder.addCase(resetAdminAttendanceSheetsRetrieval, () => initialState);
  },
);
